"use strict";

define('components/filter_bar/filters/extension_field_filters',[], function() {
    var extensionFieldFiltersComponent = {
        initWithContext: function(context) {
            // TODO: This component's DOM queries
            // should be scoped to context.containerNode
            // Need to check DOM placement of #show-ext-filters

            var revealer = $('#show-ext-filters');
            
            revealer.click(function(e) {
                revealer.toggleClass('btn-info')
                        .toggleClass('selected');
                
                $('#ext-filters').toggleClass('hidden');
                $('.table-scroller-viewport').trigger('scroll'); // To recalculate the header and other positions so view renders without any problem.
            });
        }
    };

    return extensionFieldFiltersComponent;
});

